let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("906hH")).then(() => parcelRequire('7SEhj'));